export default [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    access: true
  },
  {
    name: 'Messages',
    url: '/messages',
    icon: 'icon-envelope-open',
    access: true
  },
  {
    name: 'Notifications',
    url: '/notifications',
    icon: 'icon-bell',
    access: true
  },
  {
    name: 'Signoff Forms',
    url: '/signoff_forms',
    icon: 'icon-pencil',
    access: true
  },
  {
    name: 'Training Plan',
    icon: 'icon-calendar',
    url: '/training_plan'
  },
  {
    name: 'Video Library',
    url: '/videos',
    icon: 'icon-social-youtube',
    access: true
  },
  {
    name: 'Evidence Gallery',
    url: '/evidence_gallery',
    icon: 'icon-screen-smartphone',
    access: ['student']
  },
  {
    name: 'Units',
    access: ['admin', 'super_admin', 'content_curator'],
    icon: 'icon-layers',
    children: [
      {
        name: 'Units Manager',
        icon: 'icon-notebook',
        url: '/units',
        access: ['admin', 'super_admin', 'content_curator']
      },
      {
        name: 'Streams Manager',
        icon: 'icon-book-open',
        url: '/streams',
        access: ['admin', 'super_admin', 'content_curator']
      }
    ]
  },
  {
    name: 'Forms',
    //access: true,
    icon: 'icon-docs',
    children: [
      {
        name: 'Submissions',
        access: true,
        icon: '',
        url: '/submissions'
      },
      {
        name: 'Edit Forms',
        access: ['admin', 'super_admin', 'content_curator'],
        icon: '',
        url: '/forms'
      }
    ]
  },
  {
    name: 'Users',
    //url: '/users',
    icon: 'icon-user',
    access: ['admin', 'rto', 'rto_trainer', 'employer', 'trainer', 'super_admin'],
    children: [
      {
        name: 'Add New',
        url: '/users/create',
        icon: 'icon-user',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer']
      },
      {
        name: 'Apprenticeship',
        url: '/users?role_id=6&enabled=1',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer', 'employer', 'trainer']
      },
      {
        name: 'Green Card',
        url: '/users?role_id=7&enabled=1',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer', 'employer', 'trainer']
      },
      {
        name: 'Silver Card',
        url: '/users?role_id=8&enabled=1',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer', 'employer', 'trainer']
      },
      {
        name: 'Gold Card',
        url: '/users?role_id=9&enabled=1',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer', 'employer', 'trainer']
      },
      {
        name: 'Platinum Card',
        url: '/users?role_id=10&enabled=1',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer', 'employer', 'trainer']
      },
      {
        name: 'Supervisor',
        url: '/users?role_id=5&enabled=1',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer']
      },
      {
        name: 'Employers',
        url: '/users?role_id=4&enabled=1',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer']
      },
      {
        name: 'RTO Trainers',
        url: '/users?role_id=14&enabled=1',
        access: ['admin', 'super_admin', 'rto']
      },
      {
        name: 'RTO Admins',
        url: '/users?role_id=13&enabled=1',
        access: ['admin', 'super_admin']
      },
      {
        name: 'Content Curator',
        url: '/users?role_id=15&enabled=1',
        access: ['admin', 'super_admin']
      },
      {
        name: 'Admins',
        url: '/users?role_id=2&enabled=1',
        access: ['super_admin']
      },
      {
        name: 'Super Admins',
        url: '/users?role_id=1&enabled=1',
        access: ['super_admin']
      },
      {
        name: 'Disabled Users',
        url: '/users?enabled=0',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer']
      }
    ]
  },
  {
    name: 'Reports',
    icon: 'icon-chart',
    access: ['admin', 'super_admin', 'rto', 'rto_trainer'],
    children: [
      {
        name: 'User Activity',
        icon: 'icon-user-following',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer'],
        url: '/reports/user_activity'
      },
      {
        name: 'User Reports',
        icon: 'icon-layers',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer'],
        url: '/reports/user_reports'
      },
      {
        name: 'Signoff Forms',
        icon: 'icon-book-open',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer'],
        url: '/reports/signoff_forms'
      }
    ]
  },
  {
    name: 'Tools',
    icon: 'icon-compass',
    access: ['admin', 'super_admin', 'rto', 'rto_trainer', 'content_curator'],
    children: [
      {
        name: 'File Browser',
        icon: 'icon-folder',
        access: ['admin', 'super_admin', 'rto', 'rto_trainer'],
        url: '/tools/filebrowser'
      },
      {
        name: 'Upload Video',
        icon: 'icon-cloud-upload',
        access: ['admin', 'super_admin', 'content_curator'],
        url: '/videos/upload'
      },
      {
        name: 'Roles',
        icon: 'icon-people',
        access: ['admin', 'super_admin'],
        url: '/tools/roles'
      },
      {
        name: 'RTOs',
        icon: 'icon-briefcase',
        access: ['admin', 'super_admin'],
        url: '/tools/rtos'
      },
      {
        name: 'Analytics',
        icon: 'icon-graph',
        access: ['admin', 'super_admin'],
        url: '/tools/analytics'
      }
    ]
  }
]
